'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _d2 = require('d3');

var d3 = _interopRequireWildcard(_d2);

var _d3ScaleChromatic = require('d3-scale-chromatic');

var d3Chromatic = _interopRequireWildcard(_d3ScaleChromatic);

var _d3Tip = require('d3-tip');

var _d3Tip2 = _interopRequireDefault(_d3Tip);

var _topojson = require('topojson');

var topojson = _interopRequireWildcard(_topojson);

var _d3SvgLegend = require('d3-svg-legend');

var _d3SvgLegend2 = _interopRequireDefault(_d3SvgLegend);

require('./choropleth.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var prepareOptions = function prepareOptions(data) {
  // check for required options
  if (!data.measureId) {
    throw new Error('data.measureId not defined');
  }
  var temporal = data.temporal || '2000-' + new Date().getFullYear();
  // temporal can be either: string (one year YYYY), string (year range YYYY-YYYY), array of strings (years)
  if (typeof temporal === 'string' && temporal.length === 9) {
    // YYYY-YYYY
    var _temporal$split = temporal.split('-'),
        _temporal$split2 = _slicedToArray(_temporal$split, 2),
        start = _temporal$split2[0],
        stop = _temporal$split2[1];

    if (start > stop) {
      throw new Error('data.temporal not valid');
    }
    temporal = [];
    /*eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }]*/
    for (var i = start; i <= stop; i++) {
      temporal.push(i.toString());
    }
  } else if (!Array.isArray(temporal) && typeof temporal === 'string' && temporal.length !== 4) {
    throw new Error('data.temporal not valid');
  }
  // check queryParams: only support max one stratification / query parameter 
  if (data.queryParams && (data.queryParams.match(',') || data.queryParams.match('&'))) {
    throw new Error('only one stratificaiton and query paramter is allowed');
  }
  var options = {
    measureId: data.measureId, // required, no default
    stratificationLevelId: data.stratificationLevelId || '1', // default state
    temporal: temporal,
    isSmoothed: data.isSmoothed || '0', // default not smoothed
    queryParams: data.queryParams ? '?' + data.queryParams : '' // not required, no default
  };
  return options;
};

var choropleth = function choropleth(container, data, title) {
  var showLegend = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var breakGroups = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 8;
  var colorScheme = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'schemeYlGn';

  var options = prepareOptions(data);
  var url = 'https://ephtracking.cdc.gov/DataExplorer/getCoreHolder/' + options.measureId + '/' + options.stratificationLevelId + '/ALL/ALL/' + options.temporal + '/' + options.isSmoothed + '/0' + options.queryParams;
  // container
  var svg = d3.select(container);
  var isMultiYear = Array.isArray(options.temporal);

  svg.append('text').attr('class', 'loading').attr('x', 25).attr('y', 25).text('fetching data...');

  d3.json(url, function (error, response) {
    svg.selectAll('.loading').remove();
    if (error) {
      console.error(error);
    } else if (response[response.tableReturnType] && response[response.tableReturnType].length > 0) {

      // zoom on click
      var clicked = function clicked(d) {
        if (active.node() === this) return reset();
        active.classed('active', false);
        active = d3.select(this).classed('active', true);

        var bounds = path.bounds(d),
            dx = bounds[1][0] - bounds[0][0],
            dy = bounds[1][1] - bounds[0][1],
            x = (bounds[0][0] + bounds[1][0]) / 2,
            y = (bounds[0][1] + bounds[1][1]) / 2,
            scale = 0.9 / Math.max(dx / width, dy / height),
            translate = [width / 2 - scale * x, height / 2 - scale * y];

        mapGroup.transition().duration(750).style('stroke-width', 1.5 / scale + 'px').attr('transform', 'translate(' + translate + ')scale(' + scale + ')');
      };

      var reset = function reset() {
        active.classed('active', false);
        active = d3.select(null);

        mapGroup.transition().duration(750).style('stroke-width', '1.5px').attr('transform', '');
      };

      var top = title ? 50 : 20;
      var margin = { top: top, right: 20, bottom: 20, left: 20 };
      var width = +svg.attr('width') - margin.left - margin.right;
      var height = +svg.attr('height') - margin.top - margin.bottom;
      var active = d3.select(null);
      var startYear = Array.isArray(options.temporal) ? options.temporal[0] : options.temporal;
      // let currentYear = year;
      var currentYear = Number.parseInt(startYear, 10);
      var mapGroup = svg.append('g');
      var responseData = response[response.tableReturnType];
      var geographicTypeId = responseData[0].geographicTypeId;

      // create title
      if (title) {
        svg.append('text').attr('x', svg.attr('width') / 2).attr('y', margin.top / 2).attr('text-anchor', 'middle').attr('font-family', 'Verdana, Geneva, sans-serif').attr('font-size', '14px').text(title);
      }
      // year
      svg.append('text').attr('class', 'year').attr('x', svg.attr('width') / 2).attr('y', margin.top / 2 + 17).attr('text-anchor', 'middle').attr('font-family', 'Verdana, Geneva, sans-serif').attr('font-size', '14px').text(currentYear);

      // color scheme
      var color = d3.scaleQuantile().domain(responseData.map(function (d) {
        return d.dataValue;
      })).range(d3Chromatic[colorScheme][breakGroups > 2 ? breakGroups : 8]);

      // create legend
      if (showLegend) {
        svg.append('g').attr('class', 'legendMap').attr('transform', 'translate(1000, 20)');

        var legendMap = _d3SvgLegend2.default.legendColor().shapeWidth(30).classPrefix('ephviz-').cells(10).scale(color);
        svg.select('.legendMap').call(legendMap);
      }

      // create source at bottom
      svg.append('a')
      // .attr('transform', `translate(10, ${svg.attr('height') - 10})`)
      .attr('xlink:href', 'https://ephtracking.cdc.gov').attr('target', '_blank').append('text').attr('x', 10).attr('y', svg.attr('height') - 10).attr('font-family', 'Verdana, Geneva, sans-serif').attr('font-size', '11px').attr('fill', '#808080').text('Source: National Environmental Public Health Tracking Network, CDC');

      // === Create Choropleth Map ===
      var path = d3.geoPath();

      var min = d3.min(responseData, function (d) {
        return parseInt(d.dataValue, 10);
      });
      var max = d3.max(responseData, function (d) {
        return parseInt(d.dataValue, 10);
      });

      // map by geoId
      var ephdata = d3.nest().key(function (d) {
        return d.geoId;
      }).entries(responseData);

      /* Initialize tooltip */
      var tip = (0, _d3Tip2.default)().attr('class', 'd3-tip').html(function (d) {
        var data = ephdata.find(function (entry) {
          return entry.key === d.id;
        });
        if (data) {
          var yearsDatum = data.values.find(function (item) {
            return item.year.substr(item.year.length - 4) === currentYear.toString();
          });
          if (yearsDatum) {
            return yearsDatum.rollover + ' (' + yearsDatum.title + ')';
          }
        }
        return 'no data';
      });
      svg.call(tip);

      var drawMap = function drawMap(us) {
        if (geographicTypeId === 2) {
          mapGroup.append('g').attr('class', 'counties').selectAll('path').data(topojson.feature(us, us.objects.counties).features).enter().append('path').attr('fill', function (d) {
            var data = ephdata.find(function (entry) {
              return entry.key === d.id;
            });
            if (data) {
              var yearsDatum = data.values.find(
              // in case of a time period, eg '2000-2004'
              function (item) {
                return item.year.substr(item.year.length - 4) === startYear.toString();
              });
              if (yearsDatum) {
                return color(yearsDatum.dataValue);
              }
            }
            return 'lightgrey';
          }).attr('d', path).on('click', clicked).on('mouseover', tip.show).on('mouseout', tip.hide);

          // draw state border
          mapGroup.append('path').datum(topojson.mesh(us, us.objects.states, function (a, b) {
            return a !== b;
          })).attr('class', 'states').attr('d', path);
        } else if (geographicTypeId === 1) {
          // STATES
          mapGroup.append('g').attr('class', 'states').selectAll('path').data(topojson.feature(us, us.objects.states).features).enter().append('path').attr('class', 'state').attr('fill', function (d) {
            var data = ephdata.find(function (entry) {
              return entry.key === d.id;
            });
            if (data) {
              var yearsDatum = data.values.find(function (item) {
                return item.year.substr(item.year.length - 4) === startYear.toString();
              });
              if (yearsDatum) {
                return color(yearsDatum.dataValue);
              }
            }
            return 'lightgrey';
          }).attr('d', path).on('click', clicked).on('mouseover', tip.show).on('mouseout', tip.hide);
        }
      };

      var animateMap = function animateMap(us) {
        var i = 1; // first year is already rendered
        var max = Array.isArray(options.temporal) ? options.temporal.length : 1;
        var interval = setInterval(function () {
          currentYear = Number.parseInt(options.temporal[i], 10);
          svg.selectAll('.year').text(currentYear);
          svg.selectAll('.replay').remove();

          // we need to redraw almost everything, otherwise the tooltip won't update when hovered

          if (geographicTypeId === 2) {
            mapGroup.selectAll('.states').remove();
            mapGroup.selectAll('.counties').remove();
            mapGroup.append('g').attr('class', 'counties').selectAll('path').data(topojson.feature(us, us.objects.counties).features).enter().append('path').attr('fill', function (d) {
              var data = ephdata.find(function (entry) {
                return entry.key === d.id;
              });
              if (data) {
                var yearsDatum = data.values.find(function (item) {
                  return item.year.substr(item.year.length - 4) === currentYear.toString();
                });
                if (yearsDatum) {
                  return color(yearsDatum.dataValue);
                }
              }
              return 'lightgrey';
            }).attr('d', path).on('click', clicked).on('mouseover', tip.show).on('mouseout', tip.hide);

            // draw state border
            mapGroup.append('path').datum(topojson.mesh(us, us.objects.states, function (a, b) {
              return a !== b;
            })).attr('class', 'states').attr('d', path);
          } else if (geographicTypeId === 1) {
            // STATES
            mapGroup.select('.states').remove();
            mapGroup.append('g').attr('class', 'states').selectAll('path').data(topojson.feature(us, us.objects.states).features).enter().append('path').attr('class', 'state').on('click', clicked).attr('fill', function (d) {
              var data = ephdata.find(function (entry) {
                return entry.key === d.id;
              });
              if (data) {
                var yearsDatum = data.values.find(function (item) {
                  return item.year.substr(item.year.length - 4) === currentYear.toString();
                });
                if (yearsDatum) {
                  return color(yearsDatum.dataValue);
                }
              }
              return 'lightgrey';
            }).attr('d', path).on('mouseover', tip.show).on('mouseout', tip.hide);
          }

          i++;
          // done
          if (i === max) {
            clearInterval(interval);
            // replay
            svg.append('text').attr('class', 'replay').attr('x', 30).attr('y', margin.top / 2).attr('text-anchor', 'middle').attr('font-family', 'Verdana, Geneva, sans-serif').attr('font-size', '12px').text('Replay').on('click', function () {
              return animateMap(us);
            });
          }
        }, 1500);
      };

      d3.queue().defer(d3.json, 'https://unpkg.com/us-atlas@1.0.2/us/10m.json').await(function (error, us) {
        if (error) throw error;
        drawMap(us);
        if (isMultiYear) {
          animateMap(us);
        }
      });
    } else {
      d3.select(container).append('text').attr('y', '20').attr('font-family', 'monospace').text('no data');
    }
  });
};

exports.default = choropleth;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ephtracking-viz/dist/visualizations/choropleth.js
// module id = 1220
// module chunks = 0